import type { PropsWithChildren } from "react";

import { LanguageSwitch } from "@/shared/components";
import { Layout, PhoneContact } from "@/shared/ui";

export const EmbeddablesScreenLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-dvh flex-col bg-white">
      <Layout.Header
        leftSlot={<PhoneContact />}
        rightSlot={<LanguageSwitch />}
        progress={100}
      />

      {children}
    </div>
  );
};
